import { QueueWaitOfferOptionsBuilder } from './queue-wait-offer-options.builder';
import { QueueWaitOfferThresholdsBuilder } from './queue-wait-offer-thresholds.builder';
var QueueWaitOfferSettingsBuilder = /** @class */ (function () {
    function QueueWaitOfferSettingsBuilder() {
        this.queueWaitOfferSettings = {
            enabled: false,
            queueWaitOfferOptions: new QueueWaitOfferOptionsBuilder().build(),
            queueWaitOfferThresholds: new QueueWaitOfferThresholdsBuilder().build()
        };
    }
    QueueWaitOfferSettingsBuilder.prototype.withEnabled = function (enabled) {
        this.queueWaitOfferSettings.enabled = enabled;
        return this;
    };
    QueueWaitOfferSettingsBuilder.prototype.withQueueWaitOfferOptions = function (queueWaitOfferOptions) {
        this.queueWaitOfferSettings.queueWaitOfferOptions = queueWaitOfferOptions;
        return this;
    };
    QueueWaitOfferSettingsBuilder.prototype.withQueueWaitOfferThresholds = function (queueWaitOfferThresholds) {
        this.queueWaitOfferSettings.queueWaitOfferThresholds = queueWaitOfferThresholds;
        return this;
    };
    QueueWaitOfferSettingsBuilder.prototype.build = function () {
        return this.queueWaitOfferSettings;
    };
    return QueueWaitOfferSettingsBuilder;
}());
export { QueueWaitOfferSettingsBuilder };
//# sourceMappingURL=queue-wait-offer-settings.builder.js.map